import { Currency } from '~/entities/currency';
import { type PayinBalance } from '~/entities/payin';
import { type PayoutBalance } from '~/entities/payout';

export function prepareBalance(balances: PayinBalance[], currency: Currency): PayinBalance;
export function prepareBalance(balances: PayoutBalance[], currency: Currency): PayoutBalance;
export function prepareBalance(
    balances: PayinBalance[] | PayoutBalance[],
    currency: Currency,
): PayinBalance | PayoutBalance {
    const [balance] = balances.filter((balance) => {
        return balance.currency === Currency[currency];
    });

    return balance;
}
